 
import Error_page from "./pages/error"; 
import Account from "./profile/account";
import Login from "./profile/login"; 
import Install_app from "./body_root/install-app"; 
import Search_root from "./search_root/search";  
//support and dashboard
import Support from "./support_root/support"; 
import Terms_and_conditions from "./support_root/terms-and-conditions";
import Privacy_policy from "./support_root/privacy-policy";
//company root  
//status root
import Home_page from "./status_root/home";
import Post_status from "./status_root/post-status"; 
import Sitemap from "./support_root/sitemap";
import Account_profile from "./profile/account-profile";

export const Approutes = [
  { path: '/', name: 'Home Apps', element: <Home_page/> },
   { path: '/post-status', name: 'Post status', element: <Post_status /> },  
 
  //staff payments 
  { path: '/sitemap', name: 'Sitemap', element: <Sitemap /> },  
  { path: '/support', name: 'Support', element: <Support /> },
  { path: '/search', name: 'search', element: <Search_root /> }, 
  { path: '/install-app', name: 'Install App', element: <Install_app /> }, 
  { path: '/account', name: 'Profile account', element: <Account /> },
  { path: '/account-profile', name: 'account profile', element: <Account_profile /> },
  { path: '/login', name: 'Login account', element: <Login /> },
     { path: '/terms-and-conditions', name: 'Terms and onditions', element: <Terms_and_conditions /> },
          { path: '/privacy-policy', name: 'Privacy policy', element: <Privacy_policy/> },
  { path: '/sitemap', name: 'Sitemap', element: <Sitemap /> },
    { path: '/error', name: 'error', element: <Error_page /> },


];